import { forwardRef, ReactNode } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';

interface TabPanelProps {
  children?: ReactNode;
  step: string;
  currentStep: string;
}

const CustomTabPanel = forwardRef((props: PropsWithClassName<TabPanelProps>, ref) => {
  const { children, step, currentStep, ...other } = props;

  return (
    <div
      //eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      ref={ref}
      role="tabpanel"
      hidden={step !== currentStep}
      id={`simple-tabpanel-${currentStep}`}
      {...other}
    >
      {step === currentStep && children}
    </div>
  );
});

export default CustomTabPanel;
